var chunkMapping = {
	"src_app_app_tsx": [
		"webpack/container/remote/ui_core/ApiConfig",
		"webpack/container/remote/login_hircasa/Store",
		"webpack/container/remote/ui_core/GetApi",
		"webpack/container/remote/ui_core/PostApi",
		"webpack/container/remote/ui_core/PatchApi",
		"webpack/container/remote/ui_core/DeleteApi",
		"webpack/container/remote/ui_core/PutApi",
		"webpack/container/remote/ui_core/NotificationsContext"
	],
	"webpack_container_remote_ui_core_LogoUpHircasa": [
		"webpack/container/remote/ui_core/LogoUpHircasa"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/ui_core/ApiConfig": [
		"default",
		"./ApiConfig",
		"webpack/container/reference/ui_core"
	],
	"webpack/container/remote/login_hircasa/Store": [
		"default",
		"./Store",
		"webpack/container/reference/login_hircasa"
	],
	"webpack/container/remote/ui_core/GetApi": [
		"default",
		"./GetApi",
		"webpack/container/reference/ui_core"
	],
	"webpack/container/remote/ui_core/PostApi": [
		"default",
		"./PostApi",
		"webpack/container/reference/ui_core"
	],
	"webpack/container/remote/ui_core/PatchApi": [
		"default",
		"./PatchApi",
		"webpack/container/reference/ui_core"
	],
	"webpack/container/remote/ui_core/DeleteApi": [
		"default",
		"./DeleteApi",
		"webpack/container/reference/ui_core"
	],
	"webpack/container/remote/ui_core/PutApi": [
		"default",
		"./PutApi",
		"webpack/container/reference/ui_core"
	],
	"webpack/container/remote/ui_core/NotificationsContext": [
		"default",
		"./NotificationsContext",
		"webpack/container/reference/ui_core"
	],
	"webpack/container/remote/ui_core/LogoUpHircasa": [
		"default",
		"./LogoUpHircasa",
		"webpack/container/reference/ui_core"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}